export enum Permission {
    Manage_Users = 'manage-users',
    Read_Team_Time_Report = 'read-team-time-report'
}
